import React, { useState } from 'react';
import styled from 'styled-components';

const Menu = styled.div`
  border-bottom: 1px solid #d7dbe3;
  overflow-x: auto;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: #c4c8d0;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #969dab;
  }
  scrollbar-width: thin;
  scrollbar-color: #c4c8d0 #f0f0f0;

  ul {
    display: flex;
    flex-wrap: nowrap;
    padding: 32px 0px 24px 0px;
    margin: 0px;
    min-width: min-content;
  }
`;

const Stepper = props => {
  const [activeStep, setActiveStep] = useState(props.activeStep);

  return (
    <div className="stepper">
      <Menu>
        <ul>
          {props.steps.map((s, i) =>
            React.cloneElement(s.stepItem, {
              active: i === activeStep,
              onClick: () => setActiveStep(i),
            }),
          )}
        </ul>
      </Menu>
      {props.steps[activeStep].stepContent}
    </div>
  );
};

export default Stepper;
